<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbposition_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsbposition_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsbposition_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsbposition_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsbposition_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsbposition_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsbposition_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_state"
        class="form-control-label">state</label>
      <input
        id="exsbposition_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_document"
        class="form-control-label">document</label>
      <input
        id="exsbposition_document"
        v-model="item.document"
        :class="['form-control', isInvalid('document') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('document', $event.target.value)">
      <div
        v-if="isInvalid('document')"
        class="invalid-feedback">{{ violations.document }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_name"
        class="form-control-label">name</label>
      <input
        id="exsbposition_name"
        v-model="item.name"
        :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('name', $event.target.value)">
      <div
        v-if="isInvalid('name')"
        class="invalid-feedback">{{ violations.name }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_item"
        class="form-control-label">item</label>
      <input
        id="exsbposition_item"
        v-model="item.item"
        :class="['form-control', isInvalid('item') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('item', $event.target.value)">
      <div
        v-if="isInvalid('item')"
        class="invalid-feedback">{{ violations.item }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_warehouse"
        class="form-control-label">warehouse</label>
      <input
        id="exsbposition_warehouse"
        v-model="item.warehouse"
        :class="['form-control', isInvalid('warehouse') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('warehouse', $event.target.value)">
      <div
        v-if="isInvalid('warehouse')"
        class="invalid-feedback">{{ violations.warehouse }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_warehouseQuantity"
        class="form-control-label">warehouseQuantity</label>
      <input
        id="exsbposition_warehouseQuantity"
        v-model="item.warehouseQuantity"
        :class="['form-control', isInvalid('warehouseQuantity') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('warehouseQuantity', $event.target.value)">
      <div
        v-if="isInvalid('warehouseQuantity')"
        class="invalid-feedback">{{ violations.warehouseQuantity }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_newWarehouse"
        class="form-control-label">newWarehouse</label>
      <input
        id="exsbposition_newWarehouse"
        v-model="item.newWarehouse"
        :class="['form-control', isInvalid('newWarehouse') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('newWarehouse', $event.target.value)">
      <div
        v-if="isInvalid('newWarehouse')"
        class="invalid-feedback">{{ violations.newWarehouse }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_newWarehouseQuantity"
        class="form-control-label">newWarehouseQuantity</label>
      <input
        id="exsbposition_newWarehouseQuantity"
        v-model="item.newWarehouseQuantity"
        :class="['form-control', isInvalid('newWarehouseQuantity') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('newWarehouseQuantity', $event.target.value)">
      <div
        v-if="isInvalid('newWarehouseQuantity')"
        class="invalid-feedback">{{ violations.newWarehouseQuantity }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_quantity"
        class="form-control-label">quantity</label>
      <input
        id="exsbposition_quantity"
        v-model="item.quantity"
        :class="['form-control', isInvalid('quantity') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('quantity', $event.target.value)">
      <div
        v-if="isInvalid('quantity')"
        class="invalid-feedback">{{ violations.quantity }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_discount"
        class="form-control-label">discount</label>
      <input
        id="exsbposition_discount"
        v-model="item.discount"
        :class="['form-control', isInvalid('discount') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('discount', $event.target.value)">
      <div
        v-if="isInvalid('discount')"
        class="invalid-feedback">{{ violations.discount }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_pricePerUnit"
        class="form-control-label">pricePerUnit</label>
      <input
        id="exsbposition_pricePerUnit"
        v-model="item.pricePerUnit"
        :class="['form-control', isInvalid('pricePerUnit') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('pricePerUnit', $event.target.value)">
      <div
        v-if="isInvalid('pricePerUnit')"
        class="invalid-feedback">{{ violations.pricePerUnit }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_vatRate"
        class="form-control-label">vatRate</label>
      <input
        id="exsbposition_vatRate"
        v-model="item.vatRate"
        :class="['form-control', isInvalid('vatRate') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('vatRate', $event.target.value)">
      <div
        v-if="isInvalid('vatRate')"
        class="invalid-feedback">{{ violations.vatRate }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_value"
        class="form-control-label">value</label>
      <input
        id="exsbposition_value"
        v-model="item.value"
        :class="['form-control', isInvalid('value') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('value', $event.target.value)">
      <div
        v-if="isInvalid('value')"
        class="invalid-feedback">{{ violations.value }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_reason"
        class="form-control-label">reason</label>
      <input
        id="exsbposition_reason"
        v-model="item.reason"
        :class="['form-control', isInvalid('reason') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('reason', $event.target.value)">
      <div
        v-if="isInvalid('reason')"
        class="invalid-feedback">{{ violations.reason }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbposition_reasonComment"
        class="form-control-label">reasonComment</label>
      <input
        id="exsbposition_reasonComment"
        v-model="item.reasonComment"
        :class="['form-control', isInvalid('reasonComment') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('reasonComment', $event.target.value)">
      <div
        v-if="isInvalid('reasonComment')"
        class="invalid-feedback">{{ violations.reasonComment }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
